/**
 * Acesso negado pelo credenciamento (PBI-06).
 *
 * Só se chega aqui depois de a identidade estar confirmada — a ordem do login
 * é identidade, credenciamento, sessão. Por isso a tela pode dizer o nome da
 * pessoa: ela já provou quem é, e o que falta é a operadora.
 *
 * Não aparece em menu nenhum: é destino de redirecionamento. Aberta direto,
 * sem nome no estado da navegação, cai no texto genérico.
 */

import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Button, Paper, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function IdentityAccessDeniedPage() {
  const { t } = useTranslation();
  const theme = useTheme();
  const location = useLocation();
  const fullName = location.state && location.state.fullName;
  const unit = location.state && location.state.unit;

  let reason = t('identity.denied.reasonGeneric');
  if (fullName && unit) reason = t('identity.denied.reasonNamedUnit', { name: fullName, unit });
  else if (fullName) reason = t('identity.denied.reasonNamed', { name: fullName });

  return (
    <Box
      component="main"
      id="identityAccessDeniedScreen"
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        p: 3,
        bgcolor: 'background.default',
      }}
    >
      <Box sx={{ width: 'min(620px, 100%)', display: 'grid', gap: 3.5 }}>
        {/* Logo por tema, como o shell: azul da marca no claro, branco no
          * escuro. Filtro CSS sobre o logo branco sai roxo. */}
        <Box
          component="img"
          src={theme.palette.mode === 'dark' ? '/images/wes-logo-white.svg' : '/images/logo_big.svg'}
          alt="WES Hub 360"
          sx={{ width: 154, height: 'auto' }}
        />
        <Paper
          variant="outlined"
          sx={{ display: 'grid', gap: 1.75, p: 3.5, borderRadius: 2, bgcolor: 'background.paper' }}
        >
          <Box component="span" className="material-symbols-rounded" aria-hidden="true" sx={{ fontSize: 44, color: 'error.main' }}>
            gpp_bad
          </Box>
          <Typography component="h1" variant="h5" sx={{ fontWeight: 700 }}>
            {t('identity.denied.title')}
          </Typography>
          <Typography color="text.secondary">{reason}</Typography>
          <Typography color="text.secondary">{t('identity.denied.nextStep')}</Typography>
          <Box>
            <Button component={RouterLink} to="/login" variant="contained" sx={{ borderRadius: 2 }}>
              {t('identity.denied.backToLogin')}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
